import { Card, Divider, Image, Row, Space, Typography } from 'antd';
import { Button } from 'antd-mobile';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { THB } from 'helpers/formatCurrency';
import moment from 'moment';
import BookingTagStatus from 'components/global/BookingTagStatus';
import DynamicIcon from 'components/dynamic-icon';
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import Verified from '../../../../assets/img/Verified.png';
import useTranslations from '../../../../hooks/useTranslations';
import ModalSuccessBookingStyled from '../styled/ModalSuccessBooking.styled';

const { Text, Title } = Typography;

const SpaceStyled = styled(Space)`
    width: 100%;
    .ant-space-item {
        width: 100%;
    }
`;

const CardStyled = styled(Card)`
    width: 100%;
    .ant-card-head {
        .ant-card-extra,
        .ant-card-head-title {
            padding: 0px;
        }
    }
`;

function ModalSuccessBooking({ visible, onCancel, bookingData }) {
    const { t } = useTranslations();
    const navigate = useNavigate();
    const textYourOrderBookingIsCreated = t('YourOrderBookingIsCreated', 'Your order booking is created');
    const textViewBookingDetails = t('ViewBookingDetails', 'View Booking Details');
    const textBackToHome = t('BackToHome', 'Back to Home');
    const textServiceFee = t('ServiceFee', 'Service Fee');
    const textTravelFee = t('TravelFee', 'Travel Fee');
    const textTotalFee = t('TotalFee', 'Total Fee');

    return (
        <ModalSuccessBookingStyled maskClosable={false} open={visible} onCancel={onCancel} footer={null} closable={false}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '16px',
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <div className="image-verified">
                    <Image src={Verified} width={148} height={148} preview={false} />
                </div>
                <Title level={4} style={{ textAlign: 'center' }}>
                    {textYourOrderBookingIsCreated}
                </Title>
                <Text type="secondary" style={{ textAlign: 'center', display: 'block' }}>
                    Booking successful! Please wait while your therapist confirms the session.
                </Text>
                <CardStyled
                    bodyStyle={{ padding: 12 }}
                    headStyle={{ padding: 12 }}
                    title={<Text type="secondary">{bookingData?.bookingCode}</Text>}
                    extra={<BookingTagStatus status={1} />}
                >
                    <Row gutter={[0, 16]}>
                        <Space direction="vertical">
                            <Text style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ color: 'var(--primary-color)', fontSize: 24, lineHeight: 1, height: 24 }}>
                                    <DynamicIcon iconName="therapist" />
                                </span>{' '}
                                {bookingData?.service_name}
                            </Text>
                            <Text style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <ClockCircleOutlined style={{ color: 'var(--primary-color)', fontSize: 22 }} />{' '}
                                {moment.unix(bookingData?.ctime).format('HH:mm')}
                            </Text>
                            <Text style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <CalendarOutlined style={{ color: 'var(--primary-color)', fontSize: 22 }} />{' '}
                                {moment.unix(bookingData?.ctime).format('DD MMM YYYY')}
                            </Text>
                        </Space>
                        <SpaceStyled split={<Divider type="vertical" />}>
                            <Space direction="vertical" size={0}>
                                <Text type="secondary">{textServiceFee}</Text>
                                <Text>{THB(bookingData?.service_fee)}</Text>
                            </Space>
                            <Space direction="vertical" size={0}>
                                <Text type="secondary">{textTravelFee}</Text>
                                <Text>{THB(bookingData?.travel_fee)}</Text>
                            </Space>
                            <Space direction="vertical" size={0}>
                                <Text type="secondary">{textTotalFee}</Text>
                                <Text strong>{THB(bookingData?.total_price)}</Text>
                            </Space>
                        </SpaceStyled>
                    </Row>
                </CardStyled>
                <Button onClick={() => navigate(`/mybooking.list/detail/${bookingData?.bookingCode}`)} color="primary">
                    {textViewBookingDetails}
                </Button>
                <Button onClick={() => navigate('/')}>{textBackToHome}</Button>
            </div>
        </ModalSuccessBookingStyled>
    );
}

export default ModalSuccessBooking;
